<template>
  <div>
    <div class="page-header"><h2>Training</h2></div>
    <section class="page-content">
      <!-- individual elements card -->
      <div v-for="p in programs" :key="p.id" class="card">
        <!-- card head -->
        <div class="card-head">
          <h3 style="margin: .5rem 0">{{ p.title }}</h3>
          <button v-if="!p.clicked" @click.prevent="p.clicked = !p.clicked">
            See More
          </button>
        </div>
        <!-- card body  -->
        <div class="card-body" v-if="p.clicked">
          <p v-html="p.description"></p>
        </div>
        <!-- card footer  -->
        <div class="card-footer" v-if="p.clicked">
          <button
            class="btn btn-outline-dark"
            @click.prevent="p.clicked = !p.clicked"
          >
            Hide info
          </button>
        </div>
      </div>
    </section>
    <!-- use map array modifier to select only titles -->
    <ServiceForm
      :options-list="programs.map(p => p.title)"
      id="form"
    ></ServiceForm>
  </div>
</template>

<style scoped>
/* .page-content */
.page-content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
}
div.card {
  grid-column: span 1;
  border-radius: 1rem;
  box-shadow: 2px 8px 30px lightgrey;
}
.card-head {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom-style: solid;
  border-bottom: 1px;
  padding: 1rem;
}
.card-head button {
  background-color: rgba(0, 0, 0, 0);
  color: var(--tetiary-color);
  border-width: 0;
}
.card-body {
  border-width: 2px 0;
  padding: 1rem;
}
.card-footer {
  background-color: var(--secondary-color);
  padding: 0.5rem 0;
  padding: 1rem;
}
@media only screen and (max-width: 998px) {
  div.card {
    grid-column: span 2;
  }
}
</style>

<script>
import ServiceForm from "./ServiceForm.vue";

export default {
  components: {
    ServiceForm
  },
  data() {
    return {
      programs: [
        {
          title: "i-Start Incubator Program",
          description:
            "The <b>Incubator</b> moves you from ideas to post-traction stage by helping you professionally register and structure your business, develop your business model, write your business and financial plans, develop their MVP, design marketing and growth hack strategies, standardize your processes, design your accounting system and get you ready for taxation, develop your pitch deck, elevator pitch and much more. Additionally, required capital is provided to the founders that distinguish themselves 	by our 	partner organizations and investors even as industry experts are assigned to 	them as mentors to implement all they have been taught.",
          clicked: false
        },
        {
          title: "i-Scale Accelerator Program",
          description:
            "Studies by the IFC show that approximately 96% of Nigerian businesses are SMEs compared to 53% in the US and 65% in Europe, however it is saddening that 80% of these businesses fail within the first five years of their existence due to lack of experience, poor structures and processes, lack of funding etc. The Accelerator will not only equip the participants with the skills needed to model 	and brand their businesses, professionally set up sustainable business structures, , 	expand their market reach, standardize their processes but will guide them with 	Legal Documentation and establish Corporate Governance, get them ready for 	investment by handholding them to provide all required documentation needed by 	Investors. The founders that distinguished themselves will receive required capital 	provided by our partner organizations and investors. Also expert mentors are 	assigned to them as to implement all they have been taught.",
          clicked: false
        },
        {
          title: "In-plant Training",
          description:
            "We also provide in-plant training for organizations targeted at all management level in order to help improve staff knowledge, skills and attitude so as to increase performance and boost productivity.",
          clicked: false
        },
        {
          title: "Local and International Trainers/Facilitators Sourcing",
          description:
            "We help organizations get subject focused experts for their training programs both locally and internationally to ensure that the overall training benefits, experience and objectives are fully maximized.",
          clicked: false
        },
        {
          title: "Incubator/Accelerator Curriculum Designs and Facilitation",
          description:
            "If you need innovative and research based curriculum for your Incubator/Accelerator programs then we are the go to organization to give you that top notch service. In addition to designing your curriculum we can also help you facilitate the program in the most world class and professional manner.",
          clicked: false
        }
      ],
      clicked: false
    };
  }
};
</script>
